module.exports = __webpack_public_path__ + "static/media/rear-right.cfcfeaf5.svg";